module.exports = __webpack_public_path__ + "img/kona.950b1408.png";